import { _status_code } from "./_status_code";
export const Request_MODULE = {
  namespaced: true,
  modules: {
    _status_code
  }
};
